
import ProductCallToAction from './ProductCallToAction.vue';
import ProductPrice from './ProductPrice.vue';
import QuantityField from '../../components/QuantityField.vue';
import TransitionExpand from '../../components/transitions/TransitionExpand.vue';
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Debounce } from '../../helpers';


@Component({
	name: 'MiniNavBar',
	components: {
		QuantityField,
		ProductCallToAction,
		ProductPrice,
		TransitionExpand,
	}
})

export default class MiniNavBar extends Vue {

	/* Props
	============================================*/
	@Prop({ type: Number, required: false, default: 700 })
	appearAfter: number;

	@Prop({ type: Boolean })
	hideProductCTA: boolean;

	/* REFS
	============================================*/
	$refs!: {
		miniNavWrap: HTMLElement
	}

	/* Data
	============================================*/
	activeNavId: string|null = null;
	contentRef: HTMLElement;
	questionsRef: HTMLElement;
	reviewsRef: HTMLElement;
	showMiniBar: boolean = false;
	showChangeStore: boolean = false;

	/* Computed
	============================================*/
	get product() {
		return this.$store.state.product;
	}

	get quantity() {
		return this.$store.state.quantity;
	}

	set quantity(val) {
		this.$store.commit('quantity', val);
	}

	get minBuyableQty() {
		return this.$store.getters.minBuyableQty;
	}

	get showSpecialMessageBox() {
		return this.$store.getters.showSpecialMessageBox;
	}

	get quantityExceedsStock() {
		return this.$store.getters.quantityExceedsStock;
	}

	get remainingSelectors() {
		return this.$store.getters.remainingSelectors;
	}

	get productHasStock() {
		return this.$store.getters.productHasStock;
	}

	get fulfillmentType() {
		return this.$store.state.fulfillmentType;
	}

	get localStore() {
		return this.$store.state.localStore;
	}

	get currentZip() {
		return this.$store.state.currentZip;
	}

	get productHasFulfillmentError() {
		return this.$store.getters.productHasFulfillmentError;
	}

	get isQuantityFieldHighlighted() {
		return this.productHasFulfillmentError || (this.quantityExceedsStock && this.remainingSelectors.length == 0);
	}

	get loading() {
		return this.$store.state.addingToCart;
	}


	/* Methods
	============================================*/
	handleScroll(ev: Event) {
		const htmlDoc = ev.target as HTMLDocument;
		if (!htmlDoc || !htmlDoc.documentElement) return;
		const { scrollTop } = htmlDoc.documentElement;
		if (scrollTop >= this.appearAfter) {
			this.showMiniBar = true;
			this.handleActiveEl(scrollTop);
		} else {
			this.showMiniBar = false;
		}
	}

	handleActiveEl(position: number) {
		if (!this.contentRef || !this.questionsRef || !this.reviewsRef) return;

		if (position >= this.reviewsRef.offsetTop - 150) {
			this.activeNavId = this.reviewsRef.id;
		} else if (position >= this.questionsRef.offsetTop - 150) {
			this.activeNavId = this.questionsRef.id;
		} else {
			this.activeNavId = this.contentRef.id;
		}
	}

	isActive(ref: HTMLElement) {
		if (!ref) return false;
		return ref.id === this.activeNavId ? true : false;
	}

	scrollToElement(el: HTMLElement) {
		if (!el) return;

		this.$nextTick(() => {
			const navHeight = this.$refs.miniNavWrap?.clientHeight ?? 150;

			const scrollTop = el.offsetTop - navHeight;

			window.scrollTo({
				top: scrollTop,
				behavior: 'smooth'
			});
		});
	}

	/* Lifecycle Hooks
	============================================*/
	beforeMount() {
		this.contentRef = document.getElementById('content');
		this.questionsRef = document.getElementById('pdpQA');
		this.reviewsRef = document.getElementById('pdpReviews');
	}

	mounted() {
		// Wait on initial load to avoid being triggered by browser scroll
		setTimeout(() => {
			window.addEventListener('scroll', Debounce(10, false, (e: Event) => this.handleScroll(e)), { passive: true });
		}, 1000);
	}
}

